import { Store } from '../../../store/player/types';

/**
 * Send the recording player into maintenance mode.
 * The event is triggered from the rest-default-handlers.
 */
export const onFeatureMaintenanceMode = (store: Store): void => {
  const { setLoaded, setEnableMaintenanceMode } = store.getState();

  setLoaded();
  setEnableMaintenanceMode();
};
